import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "tab-content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import { termGet, termPatch } from "@/common/api/rest/term/term";

import type { TranslationFieldsType } from "@/common/types/translation";
import type { TermType, TermPayloadType } from "@/common/types/term/term";

import { breadcrumbSimple, iconMenu, svgIcon } from "@/common/components";
import FormTerm from "@/components/forms/form-term.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const { t, locale } = useI18n();
const router = useRouter();
const route = useRoute();

const termData = ref<TermType | null>(null);

const termId = computed(() => route.params.term as string);

const breadcrumbList = computed(() => [
	{
		key: "register",
		label: t("common.labels.registrations"),
		url: "/register",
	},
	{
		key: "terms",
		label: t("common.labels.terms"),
		url: "/register/term",
	},
	{
		key: "edit",
		label: t("common.labels.edit"),
	},
]);

async function changeMenu(url: string) {
	router.push(url);
}

function fetchData() {
	termGet(termId.value)
		.then((response) => {
			const { success, data, message } = response;
			if (success) {
				termData.value = {
					...data,
				};
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		});
}

function patchData(payload: Partial<TermPayloadType>) {
	const newPayload = { ...payload };

	termPatch(termId.value, newPayload)
		.then((response) => {
			const { success, message } = response;

			if (success) {
				fetchData();
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		});
}

function back() {
	router.push(`/register/term`);
}

onMounted(() => {
	fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(svgIcon), {
            icon: "plans",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("term.labels.edit_term")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(FormTerm, {
          data: termData.value,
          "is-patch": true,
          "onUpdate:data": _cache[1] || (_cache[1] = ($event: any) => (patchData($event)))
        }, null, 8, ["data"])
      ])
    ])
  ]))
}
}

})